import { TRarity, TSchemaName } from "@pro/common/conf/AssetConf";
import { EosSymbol } from "../eos";

export enum EProjEnv
{
	dev = "dev",
	stage = "stage",
	testnet = "testnet",
	prod = "prod",
}

export type TProjEnv = keyof typeof EProjEnv;

type TPowerSchemas = Exclude<TSchemaName, "packs">;
type TPowerConf = Record<TPowerSchemas, Record<TRarity, number>>;

const MANA_MINING_POWER: TPowerConf = {
	symbols: {
		common: 1,
		rare: 2,
		unique: 5,
		epic: 6,
		legendary: 10,
		mythic: 200,
	},
	books: {
		common: 10,
		rare: 20,
		unique: 50,
		epic: 60,
		legendary: 100,
		mythic: 500,
	},
	heroes: {
		common: 10,
		rare: 20,
		unique: 50,
		epic: 60,
		legendary: 100,
		mythic: 500,
	}
};

export interface IChainConf
{
	readonly PROJ_ENV: TProjEnv;
	readonly SYS_TOKEN: EosSymbol;
	readonly TB_ACCOUNT: string;
	readonly AA_ACCOUNT: string;
	readonly AD_ACCOUNT: string;
	readonly MN_ACCOUNT: string;
	readonly BACKEND_ACCOUNT: string;
	readonly COLLECTION_NAME: string;
	readonly COLLECTION_AUTHOR: string;
	readonly MARKET_FEE: number;
	readonly MANA_TOKEN: EosSymbol;
	readonly MANA_MINING_POWER: TPowerConf;
	readonly CLAIM_INTERVAL_SECS: number;
	readonly HERO_PACK_PRICE: number;
}

const defaultConf: Omit<IChainConf, "PROJ_ENV"> = {
	SYS_TOKEN: new EosSymbol("WAX", 8),
	TB_ACCOUNT: "tribalbooks",
	AA_ACCOUNT: "atomicassets",
	AD_ACCOUNT: "atomicdropsx",
	MN_ACCOUNT: "tribalbooksm",
	BACKEND_ACCOUNT: "prospectorsb",
	COLLECTION_NAME: "tribalbooks",
	COLLECTION_AUTHOR: "tribalbooks",
	MARKET_FEE: 0.08,
	MANA_TOKEN: new EosSymbol("MANA", 0),
	MANA_MINING_POWER: MANA_MINING_POWER,
	CLAIM_INTERVAL_SECS: 86400,
	HERO_PACK_PRICE: 6000,
}

const chains: readonly IChainConf[] = [{
	PROJ_ENV: "dev",
	...defaultConf,
}, {
	PROJ_ENV: "stage",
	...defaultConf,
}, {
	PROJ_ENV: "prod",
	...defaultConf,
}, {
	PROJ_ENV: "testnet",
	...defaultConf,
	TB_ACCOUNT: "tribalbooksz",
	COLLECTION_NAME: "tribalbooksz",
	COLLECTION_AUTHOR: "tribalbooksz",
}];

export class ChainConf
{
	static get(projEnv: TProjEnv): IChainConf
	{
		let result = chains.find(it => it.PROJ_ENV === projEnv)
		if (!result)
			throw new Error(`ChainConf not found: ${projEnv}`);
		return result;
	}

	static get all(): readonly IChainConf[]
	{
		return chains;
	}
}
